require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-given-the-immense-value-that-forests-provide-to-communities.json") })
        }
      }, "path---en-us-update-given-the-immense-value-that-forests-provide-to-communities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-given-the-immense-value-that-forests-provide-to-communities!./.cache/json/en-us-update-given-the-immense-value-that-forests-provide-to-communities.json
// module id = 672
// module chunks = 231608221292675